import React, { useEffect, useState, useMemo } from 'react';
import InputTextComp from "@components/UI/InputText/Index.jsx";
import ButtonComp from "@components/UI/Button/Index.jsx";
import SelectOptionComp from '@components/UI/SelectOption/Index.jsx';
import InputDatePickerComp from '@components/UI/InputDatePicker/Index.jsx';
import { useFetchDataUnidades } from '@hooks/api/Unidade/useFetchDataUnidades.js';
import { useFetchDataAuditores } from '@hooks/api/Usuario/useFetchDataAuditores.js';
import { useFetchDataProcessos } from '@hooks/api/Processo/useFetchDataProcessos.js';
import { tipoComplianceOptions } from "@enums/Compliance/Index.jsx";
import { statusAuditoriaOptions } from '@components/UI/StatusSolicitacao/Index.jsx';
import dayjs from 'dayjs';
import { Alert } from 'antd';

// Centralize valores iniciais para usar no clear/reset
const initialValues = {
  tipoCompliance: "",
  numeroSolicitacao: "",
  dataSolicitacaoInicial: "",
  dataSolicitacaoFinal: "",
  nomeUnidadeGerencia: "",
  nomeAuditor: "",
  nomeProcesso: "",
  statusSolicitacao: "",
};

const FilterAdmin = ({ setFilters }) => {
  const [tempValues, setTempValues] = useState(initialValues);

  // Custom hooks para options
  const { unitOptions, unitLoading, fetchUnits } = useFetchDataUnidades();
  const { auditoresOptions, auditoresLoading, fetchAuditores } = useFetchDataAuditores();
  const { processosOptions, processosLoading, fetchProcessos } = useFetchDataProcessos();

  // Carrega selects ao montar
  useEffect(() => {
    fetchUnits();
    fetchAuditores();
    fetchProcessos();
  }, []);

  // Atualiza campo genérico
  const handleTempChange = (field, value) => {
    setTempValues(prev => ({ ...prev, [field]: value }));
  };

  // Máscara Nº Solicitação
  const handleSolicitacaoInput = e => {
    const value = e.target.value.replace(/-/g, '').toUpperCase();
    const formatted = [
      value.slice(0, 3),
      value.slice(3, 6),
      value.slice(6, 10),
      value.slice(10, 13),
    ].filter(Boolean).join('-');
    handleTempChange("numeroSolicitacao", formatted);
  };

  // Aplicar filtros
  const handleSearch = (e) => {
    e.preventDefault();
    setFilters({
      tipoCompliance: tempValues.tipoCompliance?.value || "",
      numeroSolicitacao: tempValues.numeroSolicitacao,
      dataSolicitacaoInicial: tempValues.dataSolicitacaoInicial,
      dataSolicitacaoFinal: tempValues.dataSolicitacaoFinal,
      nomeUnidadeGerencia: tempValues.nomeUnidadeGerencia?.label || "",
      nomeAuditor: tempValues.nomeAuditor?.label || "",
      nomeProcesso: tempValues.nomeProcesso?.label || "",
      statusSolicitacao: tempValues.statusSolicitacao?.value || "",
    });
  };
  
  // Limpar filtros
  const handleClearFilter = () => {
    setTempValues(initialValues);
    setFilters(initialValues);
  };

  return (
    <form onSubmit={handleSearch} className="form">

      <div className="row col-md-12">
        <div className="col-md-8 mt-2">

          <SelectOptionComp
            label="Compliance"
            options={tipoComplianceOptions}
            value={tempValues.tipoCompliance}
            onChange={val => handleTempChange("tipoCompliance", val)}
            placeholder="Selecionar um compliance"
            isClearable
          />
          <InputTextComp
            label="Nº Da Solicitação"
            value={tempValues.numeroSolicitacao}
            onChange={handleSolicitacaoInput}
            placeholder="Preencher com o número da solicitação."
            maxLength={16}
          />
          <div className='d-flex'>
            <div className='col-md-6'>
              <InputDatePickerComp
                label="Data Inicial Criação"
                value={tempValues.dataSolicitacaoInicial ? dayjs(tempValues.dataSolicitacaoInicial, "YYYY-MM-DD") : null}
                onChange={selected => handleTempChange("dataSolicitacaoInicial", selected ? selected.format("YYYY-MM-DD") : "")}
                placeholder="Selecionar"
                format="DD/MM/YYYY"
              />
            </div>
            <div className='col-md-6'>
              <InputDatePickerComp
                label="Data Final Criação"
                value={tempValues.dataSolicitacaoFinal ? dayjs(tempValues.dataSolicitacaoFinal, "YYYY-MM-DD") : null}
                onChange={selected => handleTempChange("dataSolicitacaoFinal", selected ? selected.format("YYYY-MM-DD") : "")}
                placeholder="Selecionar"
                format="DD/MM/YYYY"
              />
            </div>
          </div>
          <SelectOptionComp
            label="Unidade/Gerência"
            options={unitOptions}
            value={tempValues.nomeUnidadeGerencia}
            onChange={val => handleTempChange("nomeUnidadeGerencia", val)}
            placeholder="Selecionar uma unidade/gerência"
            isLoading={unitLoading}
            isClearable
          />
          <SelectOptionComp
            label="Auditor"
            options={auditoresOptions}
            value={tempValues.nomeAuditor}
            onChange={val => handleTempChange("nomeAuditor", val)}
            placeholder="Selecionar um auditor(a)"
            isLoading={auditoresLoading}
            isClearable
          />
          <SelectOptionComp
            label="Processo"
            options={processosOptions}
            value={tempValues.nomeProcesso}
            onChange={val => handleTempChange("nomeProcesso", val)}
            placeholder="Selecionar um processo"
            isLoading={processosLoading}
            isClearable
          />
          <SelectOptionComp
            label="Status"
            options={statusAuditoriaOptions}
            value={tempValues.statusSolicitacao}
            onChange={val => handleTempChange("statusSolicitacao", val)}
            placeholder="Selecionar um status"
            isClearable
          />
        </div>

        {/* Botões */}
        <div className="col-8 col-md-8 d-flex flex-wrap justify-content-end mt-4">
          <ButtonComp
            type="submit"
            title="Aplicar filtro"
            buttonColor="#2b97be"
            classnameIcon="fa-solid fa-filter"
            hoverMessage="Botão para aplicar o filtro da consulta"
          />
          <ButtonComp
            type="button"
            onClick={handleClearFilter}
            title="Limpar filtro"
            buttonColor="#125578"
            classnameIcon="fa-regular fa-circle-xmark"
            hoverMessage="Botão para limpar os campos de filtros preenchidos"
          />
        </div>
      </div>
    </form>
  );
};

export default FilterAdmin;
